import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAudioUrl } from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = ({ bailiffId, slot }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------

  // GET AUDIO URL
  useEffect(() => {
    if (bailiffId && slot) {
      dispatch(getAudioUrl({ bailiff: bailiffId, part: slot }));
    }
  }, [bailiffId, slot, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
